import React from 'react';
import { Container, Button, Card } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que el siguiente renderizado muestre la UI alternativa.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // También puedes registrar el error en un servicio de reporte de errores
        console.error("ErrorBoundary caught an error", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // UI de respaldo personalizada
            return (
                <Container className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
                    <Card className="text-center p-4 shadow-sm border-0" style={{ maxWidth: '500px' }}>
                        <div className="mb-4 text-danger">
                            <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '4rem' }}></i>
                        </div>
                        <Card.Title className="h3 mb-3">¡Ups! Algo salió mal</Card.Title>
                        <Card.Text className="text-muted mb-4">
                            Ha ocurrido un error inesperado en la aplicación. Hemos registrado el problema y estamos trabajando para solucionarlo.
                        </Card.Text>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="text-start bg-light p-3 rounded mb-4 overflow-auto" style={{ maxHeight: '200px', fontSize: '0.8rem' }}>
                                <code className="text-danger">
                                    {this.state.error.toString()}
                                </code>
                            </div>
                        )}

                        <div className="d-grid">
                            <Button variant="primary" onClick={this.handleReload} className="btn-lg">
                                <i className="bi bi-arrow-clockwise me-2"></i>
                                Recargar Página
                            </Button>
                        </div>
                    </Card>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
